<div class="continer">
  <div class="row justify-content-center">
    <div class="card bg-dark text-light col" style="width: 18rem;">
      <div class="card-body">
        <h5 class="card-title">Play one by one</h5>
        <p class="card-text">You are at least 2 people who want to play against eachother.</p>
        <a routerLink="/solo" routerLinkActive="active" class="btn btn-primary">We'll play solo!</a>
      </div>
    </div>
    <div class="card bg-dark text-light col" style="width: 18rem;">
      <div class="card-body">
        <h5 class="card-title">Play in teams</h5>
        <p class="card-text">You're at least 4 people who want's to play 2 against 2.</p>
        <a routerLink="/teams" routerLinkActive="active" class="btn btn-primary">Go, go, go, team!</a>
      </div>
    </div>
  </div>
</div>